import { Typography } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import NoStrategies from 'crono-fe-common/icons/No-Strategies';
import { colors } from 'crono-fe-common/theme';
import React from 'react';

interface IProps {
  style?: React.CSSProperties;
  size?: 'small' | 'medium';
  archived?: boolean;
}

export const StrategySearchEmptyState = ({
  style,
  size = 'medium',
  archived = false,
}: IProps) => (
  <FlexDiv direction="column" gap="20px" style={style}>
    <NoStrategies width={size === 'medium' ? '200px' : '136px'} />
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Typography
        fontSize={size === 'medium' ? '16px' : '14px'}
        fontWeight={600}
        textAlign={'center'}
      >
        {`No ${archived ? 'archived' : ''} sequences found with these filters`}
      </Typography>
      <Typography
        fontSize={size === 'medium' ? '14px' : '12px'}
        fontWeight={500}
        color={colors.grey11}
        textAlign={'center'}
        maxWidth={'300px'}
      >
        {`Try to change the applied filters to see all the available ${archived ? 'archived' : ''} sequences.`}
      </Typography>
    </div>
  </FlexDiv>
);
